export const VIEW_STORAGE_KEY = "dsite-admin-seo-view";

export const TAB_META = {
  aio: {
    simple: "AIO 종합 진단",
    dev: "AIO",
    intro: "검색·AI 답변·회사 정보·생성형 검색·LLM 이해도를 한곳에서 봅니다. 숫자는 공개 근거 준비도이며 순위나 추천 확률이 아닙니다.",
  },
  common: {
    simple: "검색 기본 설정",
    dev: "공통 SEO",
    intro: "사이트 전체에서 공통으로 사용할 검색 제목, 설명, SNS 공유 정보를 관리합니다.",
  },
  pages: {
    simple: "페이지 검색 설정",
    dev: "페이지별 SEO",
    intro: "각 페이지마다 검색 결과 제목과 설명을 따로 지정합니다. 비어 있으면 검색 기본 설정 값이 사용됩니다.",
  },
  aeo: {
    simple: "AI 답변 최적화",
    dev: "AEO",
    intro: "ChatGPT 같은 AI가 DSITESOLUTION의 서비스와 전문성을 질문에 맞게 이해하도록 답변 구조를 관리합니다.",
  },
  queries: {
    simple: "노출시키고 싶은 검색 질문",
    dev: "Target Query",
    intro: "고객이 실제로 검색하거나 AI에게 물어볼 질문을 등록하고, 어떤 서비스·가이드·근거가 연결되어 있는지 관리합니다.",
  },
  evidence: {
    simple: "검색 근거 연결",
    dev: "근거 맵",
    intro: "서비스, 가이드, 포트폴리오, 전문성 자료가 특정 검색 질문을 얼마나 뒷받침하는지 확인합니다.",
  },
  guides: {
    simple: "가이드 페이지",
    dev: "가이드",
    intro: "검색·AI가 참고할 가이드 글의 제목, 핵심 답변, 공개 여부를 관리합니다. 초안은 검색에 나가지 않습니다.",
  },
  landings: {
    simple: "서비스 페이지",
    dev: "서비스 페이지",
    intro: "각 서비스 페이지의 검색 제목, 핵심 답변, 연결 가이드·포트폴리오를 관리합니다.",
  },
  geo: {
    simple: "AI가 회사를 이해하는 정보",
    dev: "GEO",
    intro: "DSITESOLUTION이 어떤 회사인지, 어떤 기술과 서비스를 제공하는지 AI가 구조적으로 이해하도록 관리합니다.",
  },
  authority: {
    simple: "전문성 · 인증 · 경력",
    dev: "전문성·경력",
    intro: "공개해도 되는 전문성·인증·경력을 검증한 뒤 홈페이지와 검색에 내보냅니다. 원본 서류는 관리자만 봅니다.",
  },
  jsonld: {
    simple: "검색엔진용 회사 정보",
    dev: "구조화 데이터",
    intro: "검색엔진이 회사·서비스·FAQ를 구조적으로 읽도록 만드는 정보입니다. 폼에 입력한 값으로 자동 생성되며 raw JSON을 직접 고치지 않습니다.",
  },
  engines: {
    simple: "검색엔진 등록 · 상태",
    dev: "검색엔진",
    intro: "Google·Naver·Bing 소유 확인 코드와 robots/sitemap을 관리합니다. 저장 값은 Production API에 즉시 기록되며, 검색엔진이 읽는 최초 HTML은 FastComet index.php가 주입합니다. 인증 성공 여부는 각 검색엔진에서 확인하세요.",
  },
};

export const SURFACE = {
  public: { id: "public", label: "공개 화면" },
  search: { id: "search", label: "검색엔진" },
  ai: { id: "ai", label: "AI" },
  admin: { id: "admin", label: "관리자 전용" },
};

export const SEO_FIELDS = {
  site_title: {
    simple: "검색 제목",
    hint: "Google/Naver 검색 결과의 제목으로 사용됩니다. 페이지 본문에는 보이지 않고 브라우저 탭에도 표시됩니다. 약 30~60자 권장. 예: DSITESOLUTION | 맞춤형 웹개발·AI 자동화",
    surfaces: ["search", "ai"],
  },
  seo_description: {
    simple: "검색 설명",
    hint: "검색 결과 제목 아래에 표시될 설명입니다. 공개 페이지 본문에는 보이지 않습니다. 약 80~150자 권장.",
    surfaces: ["search", "ai"],
  },
  seo_keywords: {
    simple: "검색 키워드",
    hint: "일부 검색엔진이 참고하는 키워드입니다. 공개 화면에 보이지 않습니다. 쉼표로 구분하세요. 예: 맞춤형 웹개발, 병원 홈페이지, AI 자동화",
    surfaces: ["search"],
  },
  seo_og_title: {
    simple: "공유 제목",
    hint: "카카오톡·SNS로 링크를 공유할 때 표시되는 제목입니다. 비워 두면 검색 제목을 사용합니다.",
    surfaces: ["public"],
  },
  seo_og_description: {
    simple: "공유 설명",
    hint: "SNS 공유 카드에 표시되는 설명입니다. 비워 두면 검색 설명을 사용합니다. 약 60~110자 권장.",
    surfaces: ["public"],
  },
  seo_og_url: {
    simple: "공유 URL",
    hint: "SNS 공유 시 연결되는 주소입니다. 보통 사이트 대표 주소와 같습니다. 예: https://dsitesolution.com/",
    surfaces: ["public", "search"],
  },
  seo_canonical_url: {
    simple: "대표 URL",
    hint: "검색엔진에 이 사이트의 공식 주소로 알려주는 URL입니다. 공개 화면에는 보이지 않습니다. 예: https://dsitesolution.com/",
    surfaces: ["search"],
  },
  seo_google_verification: {
    simple: "Google 사이트 소유 확인",
    hint: "Google Search Console 소유 확인 코드입니다. content 값만 넣으세요. 저장 후 FastComet의 최초 HTML <head>에 주입됩니다. 검색엔진 인증 성공 여부는 Google에서 확인하세요.",
    surfaces: ["search", "admin"],
  },
  seo_naver_verification: {
    simple: "Naver 사이트 소유 확인",
    hint: "네이버 서치어드바이저 소유 확인 코드입니다. content 값만 넣으세요. 저장 후 공개 사이트 최초 HTML <head>에 반영됩니다.",
    surfaces: ["search", "admin"],
  },
  seo_bing_verification: {
    simple: "Bing 사이트 소유 확인",
    hint: "Bing Webmaster 소유 확인 코드입니다. content 값만 넣으세요. Bing은 JavaScript 실행 전 <head>의 msvalidate.01을 읽습니다.",
    surfaces: ["search", "admin"],
  },
  seo_ga_id: {
    simple: "방문자 측정 ID",
    hint: "Google Analytics 4 측정 ID입니다. 예: G-XXXXXXXXXX. ID가 있으면 공개 사이트에 gtag가 삽입됩니다. 비우면 삽입하지 않습니다.",
    surfaces: ["admin"],
  },
  seo_robots_enabled: {
    simple: "검색 수집 안내 파일 (robots.txt)",
    hint: "검색엔진에게 어떤 페이지를 수집해도 되는지 알려주는 파일입니다. 켜면 https://dsitesolution.com/robots.txt 가 Production API 설정으로 제공됩니다.",
    surfaces: ["search", "admin"],
  },
  seo_sitemap_enabled: {
    simple: "사이트 지도 (sitemap.xml)",
    hint: "검색엔진에 공개 페이지 목록을 알려주는 파일입니다. 켜면 https://dsitesolution.com/sitemap.xml 이 API에서 생성됩니다. 관리자·로그인·비공개 페이지는 넣지 않습니다.",
    surfaces: ["search", "admin"],
  },
  brand_name_en: {
    simple: "영문 브랜드명",
    hint: "AI와 검색엔진이 회사 영문 이름을 이해할 때 사용합니다. 공개 화면 일부와 구조화 데이터에 반영됩니다. 예: DSITESOLUTION",
    surfaces: ["public", "search", "ai"],
  },
  brand_alternate_names: {
    simple: "다른 표기",
    hint: "검색·AI가 헷갈리지 않도록 다른 이름·한글 표기를 적습니다. 쉼표로 구분. 예: 디사이트솔루션, Dsite Solution",
    surfaces: ["search", "ai"],
  },
  brand_summary: {
    simple: "회사 한 줄 소개",
    hint: "AI가 이 회사를 설명할 때 참고하는 요약입니다. 검색 설명과 달라도 됩니다. 약 80~180자 권장.",
    surfaces: ["ai", "search"],
  },
  brand_expertise: {
    simple: "전문 분야",
    hint: "회사가 잘하는 일을 짧게 적습니다. AI 답변과 구조화 데이터에 쓰입니다. 예: 맞춤형 웹개발, 관리자/CMS, AI 자동화",
    surfaces: ["ai", "search"],
  },
  brand_target_industries: {
    simple: "대상 산업",
    hint: "주로 돕는 업종입니다. AI가 ‘누구를 위한 회사인지’ 이해할 때 사용합니다. 예: 병원, 제조, SaaS",
    surfaces: ["ai"],
  },
  brand_service_region: {
    simple: "서비스 지역",
    hint: "서비스를 제공하는 지역입니다. 검색·AI의 지역 이해에 쓰입니다. 예: 대한민국",
    surfaces: ["search", "ai"],
  },
};

export const PAGE_SEO_FIELDS = {
  path: {
    simple: "페이지 주소",
    hint: "이 설정을 적용할 공개 페이지 주소입니다. 예: /about . 개발자 보기에서 path 값을 그대로 확인합니다.",
    surfaces: ["search", "admin"],
  },
  label: {
    simple: "관리용 이름",
    hint: "관리자가 구분하기 위한 이름입니다. 공개 화면·검색에는 보이지 않습니다.",
    surfaces: ["admin"],
  },
  seo_title: {
    simple: "검색 제목",
    hint: "Google/Naver 검색 결과의 제목으로 사용됩니다. 비워 두면 검색 기본 설정의 제목을 씁니다. 약 30~60자 권장.",
    surfaces: ["search", "ai"],
  },
  meta_description: {
    simple: "검색 설명",
    hint: "검색 결과 제목 아래에 표시될 설명입니다. 약 80~150자 권장.",
    surfaces: ["search", "ai"],
  },
  robots: {
    simple: "검색 수집",
    hint: "index,follow 이면 검색에 나갑니다. noindex 이면 검색에 아직 반영되지 않습니다. 초안 페이지는 noindex를 권장합니다.",
    surfaces: ["search", "admin"],
  },
};

export const AEO_FIELDS = {
  question: {
    simple: "질문",
    hint: "고객이 검색하거나 AI에게 물어볼 문장입니다. 공개 FAQ와 검색용 질문에 사용됩니다. 예: 병원 홈페이지에는 어떤 기능이 필요한가요?",
    surfaces: ["public", "search", "ai"],
  },
  answer: {
    simple: "답변",
    hint: "질문에 바로 답하는 문장입니다. AI와 FAQ 영역에 쓰입니다. 마케팅 문구만 쓰지 말고 먼저 답을 적으세요. 약 80~300자 권장.",
    surfaces: ["public", "search", "ai"],
  },
  category: {
    simple: "분류",
    hint: "관리·필터용 분류입니다. 예: 일반, 홈페이지, AI. 공개 화면에 작게 보일 수 있습니다.",
    surfaces: ["admin", "public"],
  },
  service_name: {
    simple: "관련 서비스",
    hint: "이 Q&A가 어떤 서비스에 대한 것인지 적습니다. 서비스 페이지와 AI 이해에 연결됩니다.",
    surfaces: ["public", "ai"],
  },
};

export const QUERY_FIELDS = {
  query: {
    simple: "검색 질문",
    hint: "고객이 실제로 검색하거나 AI에게 물어볼 문장입니다. 예: 맞춤형 웹사이트와 홈페이지의 차이가 뭔가요?",
    surfaces: ["search", "ai", "admin"],
  },
  capability_category: {
    simple: "서비스 분류",
    hint: "이 질문이 어느 역량에 속하는지 고릅니다. AI가 질문을 묶어서 이해하는 데 쓰입니다.",
    surfaces: ["ai", "admin"],
  },
  intent: {
    simple: "검색 의도",
    hint: "정보 탐색(informational)인지, 의뢰·비교(commercial)인지 적습니다. 검색·AI 분류에 쓰이며 공개 화면에는 보이지 않습니다.",
    surfaces: ["search", "ai", "admin"],
  },
  priority: {
    simple: "우선순위",
    hint: "먼저 근거를 채울 질문입니다. HIGH / MEDIUM / LOW. 공개 화면에는 보이지 않습니다.",
    surfaces: ["admin"],
  },
  landing_path: {
    simple: "대표 페이지 주소",
    hint: "이 질문에 답하는 공개 URL입니다. 예: /guides/homepage-agency-criteria",
    surfaces: ["search", "ai", "public"],
  },
  service_ids: {
    simple: "연결된 서비스",
    hint: "이 질문과 연결할 서비스 ID입니다. 공개 서비스 페이지가 검색 근거가 됩니다.",
    surfaces: ["public", "search", "ai"],
  },
  guide_ids: {
    simple: "연결된 가이드",
    hint: "이 질문에 답하는 가이드 ID입니다. 가이드가 공개되어 있어야 검색 근거로 인정됩니다.",
    surfaces: ["public", "search", "ai"],
  },
  faq_ids: {
    simple: "연결된 FAQ",
    hint: "같은 질문을 다루는 FAQ ID입니다. 페이지에 실제로 보이는 FAQ와 같아야 합니다.",
    surfaces: ["public", "search", "ai"],
  },
  portfolio_slugs: {
    simple: "연결된 포트폴리오",
    hint: "이 질문과 연결할 공개 프로젝트 주소 이름(slug)입니다. 비공개 프로젝트는 근거가 되지 않습니다.",
    surfaces: ["public", "search", "ai"],
  },
  person_ids: {
    simple: "연결된 인력",
    hint: "확인된 대표/핵심 인력 ID만 연결합니다. 공개 전문성 근거에 쓰입니다.",
    surfaces: ["ai", "admin"],
  },
  credential_ids: {
    simple: "연결된 인증·등록",
    hint: "확인된 사업자·인증 ID만 연결합니다. 검색·AI의 공식 근거가 됩니다.",
    surfaces: ["search", "ai"],
  },
};

export const GEO_ENTITY_FIELDS = {
  name: {
    simple: "서비스 이름",
    hint: "검색엔진과 AI가 읽는 서비스 이름입니다. 공개 서비스 페이지 제목과 맞추는 것이 좋습니다.",
    surfaces: ["public", "search", "ai"],
  },
  short_description: {
    simple: "짧은 설명",
    hint: "검색·AI가 서비스를 한 줄로 이해할 때 사용합니다. 약 40~120자 권장.",
    surfaces: ["search", "ai"],
  },
  detailed_description: {
    simple: "자세한 설명",
    hint: "서비스가 무엇을 하는지 구체적으로 적습니다. 구조화 데이터와 AI 이해에 쓰입니다.",
    surfaces: ["search", "ai"],
  },
  official_page_url: {
    simple: "공식 페이지 주소",
    hint: "이 서비스의 공개 URL입니다. 예: /services/homepage",
    surfaces: ["public", "search"],
  },
  label: {
    simple: "출처 이름",
    hint: "공식 자료의 이름입니다. 예: 회사 소개, 사업자 정보. 검색엔진이 출처로 참고합니다.",
    surfaces: ["search", "ai", "admin"],
  },
  url: {
    simple: "출처 주소",
    hint: "공식 페이지 또는 외부 검증 URL입니다. 공개된 주소만 넣으세요.",
    surfaces: ["search", "ai"],
  },
  source_type: {
    simple: "출처 종류",
    hint: "page / credential / profile 등. 개발자 보기에서 영문 값을 그대로 유지합니다.",
    surfaces: ["admin"],
  },
};

export const CAPABILITY_LABELS = {
  WEBSITE: "홈페이지",
  WEB_DEVELOPMENT: "웹개발",
  SAAS_PLATFORM: "SaaS 플랫폼",
  ADMIN_CMS: "관리자·CMS",
  CRM_BUSINESS: "CRM·업무",
  AI: "AI",
  AUTOMATION: "자동화",
  SEARCH_TECH: "검색 기술",
  INDUSTRY: "업종별",
};

export const MARK_MEANING = {
  O: "충분한 근거",
  "△": "일부 근거 있음",
  X: "근거 부족",
};

export const MARK_HELP = {
  service: {
    O: "이 질문에 연결된 공개 서비스가 있습니다.",
    "△": "서비스는 연결되어 있지만 설명·범위가 짧아 핵심 질문에 충분히 답하지 않습니다.",
    X: "이 질문과 연결할 공개 서비스 페이지가 없습니다. 서비스 페이지를 연결하세요.",
  },
  guide: {
    O: "이 질문에 답하는 공개 가이드가 있습니다.",
    "△": "관련 가이드는 있지만 핵심 질문에 직접 답하지 않습니다. 핵심 답변과 본문을 보강하세요.",
    X: "이 질문에 답하는 가이드가 없습니다. 관련 가이드를 연결하거나 작성하세요.",
  },
  portfolio: {
    O: "이 질문과 연결된 공개 프로젝트가 있습니다.",
    "△": "프로젝트는 연결되어 있지만 제목 또는 설명이 부족합니다. 공개 콘텐츠를 보강하세요.",
    X: "이 질문과 연결할 공개 프로젝트가 없습니다.",
  },
  landing: {
    O: "이 질문의 대표 공개 페이지가 있습니다.",
    "△": "서비스/가이드 ID는 있으나 공개된 페이지 주소가 확인되지 않습니다.",
    X: "이 질문의 대표 페이지 주소가 없거나 아직 공개되지 않았습니다.",
  },
  faq: {
    O: "이 질문 또는 연결된 공개 페이지에 FAQ가 있습니다.",
    "△": "연결된 공개 페이지는 있으나 노출되는 FAQ가 없습니다.",
    X: "이 질문에 연결된 FAQ가 없고, 연결된 공개 페이지에도 FAQ가 없습니다.",
  },
  authority: {
    O: "이 질문을 뒷받침하는 공개 전문성·인증이 있습니다.",
    "△": "회사 정보는 있으나 이 질문에 맞는 공개 전문성 근거가 부족합니다. 검증된 사실을 연결하세요.",
    X: "이 질문을 뒷받침할 공개된 전문성·인증이 없습니다.",
  },
  organization: {
    O: "회사 기본 정보가 구조화되어 있습니다.",
    "△": "회사 정보가 일부만 있습니다. 사이트 정보에서 회사명·연락처를 확인하세요.",
    X: "회사 기본 정보가 부족합니다. 사이트 정보와 GEO를 채워 주세요.",
  },
  official_source: {
    O: "공식 출처(인증·등록 페이지)가 연결되어 있습니다.",
    "△": "회사 정보는 있으나 외부 공식 출처가 약합니다.",
    X: "공식 출처가 없습니다. 인증·등록 또는 공식 페이지를 연결하세요.",
  },
};

export const FLOW_STEPS = [
  { key: "service", simple: "연결된 서비스", dev: "Service" },
  { key: "guide", simple: "가이드", dev: "Guide" },
  { key: "portfolio", simple: "포트폴리오", dev: "Portfolio" },
  { key: "authority", simple: "전문성 근거", dev: "Authority" },
];

export const AUTHORITY_EVIDENCE_LABEL = {
  private: "내부 증빙",
  verified: "검증 완료",
};

export const AUTHORITY_PUBLIC_LABEL = {
  hidden: "비공개",
  draft: "초안",
  approved: "공개 중",
};

export const IDENTITY_LABEL = {
  not_required: "본인 확인 불필요",
  pending: "본인 확인 필요",
  confirmed: "본인 확인 완료",
  rejected: "본인 확인 거절",
};

export function tabLabel(id, view) {
  const row = TAB_META[id];
  if (!row) return id;
  return view === "dev" ? row.dev : row.simple;
}

export function fieldLabel(meta, key, view) {
  if (!meta) return key;
  if (view === "dev") return `${meta.simple} (${key})`;
  return meta.simple;
}

export function displayEvidenceMark(exists, quality) {
  if (!exists || exists === "X") return "X";
  if (exists === "△") return "△";
  return "O";
}

export function markHelp(kind, mark) {
  return MARK_HELP[kind]?.[mark] || MARK_MEANING[mark] || "";
}

export function authorityReasonText(evalRow, mark) {
  if (evalRow?.reason) return evalRow.reason;
  return markHelp("authority", mark);
}

export function isUnpublished(row) {
  if (!row) return false;
  const status = String(row.status || row.public_status || "").toLowerCase();
  const robots = String(row.robots || "").toLowerCase();
  if (status === "draft" || status === "hidden") return true;
  if (robots.includes("noindex")) return true;
  return false;
}

export function authoritySurfaces(row) {
  if (!row) return ["admin"];
  const publicOk =
    row.evidence_status === "verified" &&
    row.public_status === "approved" &&
    row.identity_match !== "pending" &&
    row.identity_match !== "rejected" &&
    row.official_name_status !== "pending";
  if (publicOk) return ["public", "search", "ai"];
  return ["admin"];
}

export function pickKeys(obj, keys) {
  const out = {};
  keys.forEach((k) => {
    out[k] = obj?.[k] ?? "";
  });
  return out;
}
